<template>
  <div class="w-[200px] transition-all bg-orange-600 text-white py-4 px-2">
    <router-link :to="{name:'app.dashboard'}" class="sidebar_router" active-class="">
      <span class="mr-2 icon-wrapper">
        <HomeIcon class="w-5"></HomeIcon>
      </span>
      <span class="text-sm font-medium">
        Dashboard
      </span>
    </router-link>
    <router-link :to="{name:'app.reviews'}" class="sidebar_router">
      <span class="mr-2 icon-wrapper">
        <ListBulletIcon class="w-5"></ListBulletIcon>
      </span>
      <span class="text-sm font-medium">
        Reviews
      </span>
    </router-link>
    <router-link :to="{name:'app.youtube-videos'}" class="sidebar_router">
      <span class="mr-2 icon-wrapper">
        <ListBulletIcon class="w-5"></ListBulletIcon>
      </span>
      <span class="text-sm font-medium">
        Videos
      </span>
    </router-link>
    <router-link :to="{name:'app.galleries'}" class="sidebar_router">
      <span class="mr-2 icon-wrapper">
        <ListBulletIcon class="w-5"></ListBulletIcon>
      </span>
      <span class="text-sm font-medium">
        Galleries
      </span>
    </router-link>
  </div>
</template>

<script setup>
import {
  HomeIcon,
  ListBulletIcon
} from '@heroicons/vue/24/outline'
import {RouterLink} from 'vue-router';
</script>

<style scoped>
.sidebar_router {
  @apply flex items-center p-3 rounded-lg transition-all duration-200;
  @apply hover:bg-white hover:cursor-pointer;
  @apply hover:text-orange-600 hover:shadow-md mb-2;
}

.sidebar_router .icon-wrapper {
  @apply transition-colors duration-200;
}

.sidebar_router:hover .icon-wrapper {
  @apply text-orange-600;
}

.sidebar_router.router-link-active,
.sidebar_router.router-link-exact-active {
  @apply bg-orange-700 border-l-4 border-white;
}
</style>